// Helper to get token from localStorage
export const getToken = () => {
    try {
        const userJSON = localStorage.getItem('crm_user');
        if (userJSON) {
            const user = JSON.parse(userJSON);
            return user.token || null;
        }
        return null;
    } catch (error) {
        return null;
    }
};

// Helper to get current user from localStorage
export const getCurrentUser = () => {
    try {
        const userJSON = localStorage.getItem('crm_user');
        if (userJSON) {
            const user = JSON.parse(userJSON);
            return user || null;
        }
        return null;
    } catch (error) {
        return null;
    }
};

